import React, { Component } from "react";
import { Drawer } from "@material-ui/core";
import ChefFilters from "./Chefs";
import DishFilters from "./Dishes";

export default class  FiltersDrawer extends Component {
  render() {
    return (
      <Drawer
        open={this.props.openFiltersDrawer}
        onClose={this.props.closeFiltersDrawer}
        anchor="left"
      >
        <div
          style={{
            width: "390px",
            padding: 10,
            display: "flex",
            justifyContent: "center"
          }}
        >
          {this.props.chefs && (
            <ChefFilters onApplyFilters={this.props.onApplyFilters} closeFilters={this.props.closeFilters} />
          )}
          {this.props.dishes && (
            <DishFilters onApplyFilters={this.props.onApplyFilters} closeFilters={this.props.closeFilters}  />
          )}
        </div>
      </Drawer>
    );
  }
}
